import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Button, Card, Container, Image, Row } from "react-bootstrap";
import SearchFilter from "../../../components/SearchFilter";
import Table from "../../../components/Table";
import ConfigureColumnsDisplay from "../../../components/ConfigureColumnsDisplay";

export default function FollowPM() {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState({});
  const [showButtons, setShowButtons] = useState({});
  const [searchValue, setSearchValue] = useState({ Array: [] });
  const [data, setData] = useState({ Array: [] });
  const [columns, setColumns] = useState({ Array: [] });
  const [tabKeys, setTabKeys] = useState("Array");

  const [selectedOptions, setSelectedOptions] = useState([]);
  const searchInput = [
    {
      name: "from_date",
      label: "จาก วันที่ออกใบสั่งงาน",
      type: "Date",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "to_date",
      label: "ถึง วันที่ออกใบสั่งงาน",
      type: "Date",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "region_area",
      label: "ภูมิภาค (Area)",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "technian_name",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "service_req_no",
      label: "เลขที่ใบสั่งงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "job_type",
      label: "ประเภทงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "cus_name",
      label: "ธุรการผู้รับผิดชอบแบรนด์",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "customer_mas",
      label: "รหัสสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "item_name",
      label: "ชื่อสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 6
    }
  ];
  const columnOptions = [
    { value: "brand_administrator", label: "brand_administrator" },
    { value: "job_type", label: "job_type" },
    { value: "work_order_number", label: "work_order_number" },
    { value: "issue_date", label: "issue_date" },
    { value: "customer_branch_code", label: "customer_branch_code" },
    { value: "customer_name_branch", label: "customer_name_branch" },
    { value: "product_code", label: "product_code" },
    { value: "stock_details", label: "stock_details" },
    { value: "serial_No", label: "serial_No" },
    { value: "PM_time", label: "PM_time" },
    { value: "work_order_status", label: "work_order_status" },
    { value: "team_master_name", label: "team_master_name" },
    { value: "technician_practitioner", label: "technician_practitioner" },
    { value: "date_delegate", label: "date_delegate" },
    { value: "technician_work_status", label: "technician_work_status" },
    { value: "job_actual_date", label: "job_actual_date" },
    { value: "date_customer_receives", label: "date_customer_receives" },
    { value: "closed_work_date", label: "closed_work_date" },
    { value: "job_status", label: "job_status" }
  ];

  useEffect(() => {
    setColumns((prevCol) => ({
      ...prevCol,
      [tabKeys]: [
        {
          name: "ลำดับ",
          selector: (row) => row.rowIndex,
          sortable: true,
          width: "110px"
        }
      ]
    }));

    const newColumns = columnOptions
      .filter((option) => selectedOptions.includes(option.value))
      .map((option) => ({
        name: option.label,
        selector: (row) => row[option.value]
      }));

    setColumns((prevCol) => ({
      ...prevCol,
      [tabKeys]: [...prevCol[tabKeys], ...newColumns]
    }));
  }, [selectedOptions, tabKeys]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <>
      <Helmet>
        <title>แผน PM</title>
        <meta name="description" content="PM Plan Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Body>
            <SearchFilter
              data={data.Array}
              inputField={searchInput}
              fieldClassName={{
                actionButton: "justify-content-start align-items-center"
              }}
              searchCallback={(search) =>
                setSearchValue((prevState) => ({
                  ...prevState,
                  Array: search
                }))
              }
            />
          </Card.Body>
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-end align-items-center border-bottom-0 bg-transparent">
            <ConfigureColumnsDisplay
              options={columnOptions}
              selectedOptions={selectedOptions}
              onSelect={(values) => setSelectedOptions(values)}
            />
          </Card.Header>
          <Table
            data={data.Array}
            column={columns.Array}
            searchFilter={searchValue.Array}
            pending={loading}
            pagination
          />
        </Card>
      </Container>
    </>
  );
}
